import {
  QUESTION_LIST, 
  QUESTION_LIST_SUCCESS, 
  QUESTION_LIST_ERROR,
  QUESTION_SEARCH_SET, 
  QUESTION_SEARCH_CHANGE, 
  QUESTION_PAGE_SET,
  QUESTION_SEARCH_SECTION_LIST,
  QUESTION_SEARCH_SECTION_LIST_SUCCESS,
  QUESTION_SEARCH_SECTION_LIST_ERROR,
  QUESTION_ADD_SET,
  QUESTION_ADD_MODAL_SET,
  QUESTION_ADD,
  QUESTION_ADD_SUCCESS,
  QUESTION_ADD_ERROR,
  QUESTION_ADD_CHANGE,
  QUESTION_DETAIL,
  QUESTION_DETAIL_SUCCESS,
  QUESTION_DETAIL_ERROR,
  QUESTION_VIEW_MODAL_SET,
  QUESTION_EDIT_CHANGE,
  QUESTION_EDIT_MODAL_SET,
  QUESTION_UPDATE,
  QUESTION_UPDATE_SUCCESS,
  QUESTION_UPDATE_ERROR,
  QUESTION_VIEW_TAB_SET,
  QUESTION_UPLOAD_SET,
  QUESTION_UPLOAD_SET_SUCCESS,
  QUESTION_UPLOAD_SET_ERROR,
  QUESTION_UPLOAD_RESET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 100
    }
  },
  add: {
      data: {
        new:{ id_section: null, section: null, code: '', name: '', description: '', if_select: false, url_file: '', original_file_name: '', file_name: '' }
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      section: false
    },
    value:{
      section: false,
    },
    section:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case QUESTION_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case QUESTION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case QUESTION_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case QUESTION_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case QUESTION_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case QUESTION_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case QUESTION_SEARCH_SECTION_LIST:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          section:{
            ...state.search.section,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case QUESTION_SEARCH_SECTION_LIST_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          section:{
            ...state.search.section,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case QUESTION_SEARCH_SECTION_LIST_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          section:{
            ...state.search.section,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case QUESTION_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case QUESTION_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case QUESTION_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_section: null, section: null, code: '', name: '', description: '', if_select: false, url_file: '', original_file_name: '', file_name: ''}
          },
          modal: action.payload
        }
      }
    case QUESTION_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case QUESTION_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case QUESTION_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case QUESTION_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case QUESTION_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case QUESTION_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case QUESTION_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case QUESTION_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case QUESTION_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case QUESTION_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case QUESTION_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case QUESTION_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case QUESTION_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case QUESTION_UPLOAD_SET:
      return { ...state };
    case QUESTION_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case QUESTION_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case QUESTION_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};